import { Fragment } from 'react';

import useClubStaffDetail from './UseClubStaffDetail';

import ClubStaffAddForm from './components/forms/clubStaffAdd/ClubStaffAddForm';
import ClubStaffEditForm from './components/forms/clubStaffEdit/ClubStaffEditForm';
import ClubStaffLoadingModal from './components/dialogs/loadingModal/ClubStaffLoadingModal';

import Headings from '@usas/ui-web/components/headings/Headings';
import PopUpModal from '@usas/ui-web/components/dialogs/PopUpModal';
import SecondaryButton from '@usas/ui-web/components/buttons/SecondaryButton';

import { LOADING_MSG, SAVING_MSG } from '@usas/ui-web/utils/Constants';

const ClubStaffDetail = () => {
  const {
    isLoading,
    isSaving,
    clubStaffObj,
    staffRoleGroupId,
    registrationRoleGroupId,
    state,
    onPageError,
    onCancelClicked,
    onSubmitClubStaffAddForm,
    onSubmitClubStaffEditForm,
    onCloseValidationPopupClicked
  } = useClubStaffDetail();

  return (
    <Fragment>
      <div className="row">
        <div className="col-xs-12">
          <Headings.H3>{clubStaffObj ? 'Edit Club Staff' : 'Add Club Staff'}</Headings.H3>
        </div>
      </div>
      {clubStaffObj
        ? <ClubStaffEditForm clubStaffObj={clubStaffObj} staffRoleGroupId={staffRoleGroupId} onSubmitFormCallback={onSubmitClubStaffEditForm} onSecondaryButtonClicked={onCancelClicked} onErrorCaught={onPageError} />
        : <ClubStaffAddForm staffRoleGroupId={staffRoleGroupId} registrationRoleGroupId={registrationRoleGroupId} onSubmitFormCallback={onSubmitClubStaffAddForm} onSecondaryButtonClicked={onCancelClicked} onErrorCaught={onPageError} />
      }
      <PopUpModal
        widthPct={90}
        maxWidth={720}
        title={'Validation Error'}
        displayPopUp={state.validationErrorMessage !== ''}
        onModalCanceled={onCloseValidationPopupClicked}>
        <div className="row">
          <div className="col-xs-12">
            <p>{state.validationErrorMessage}</p>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12 usas-extra-top-margin">
            <SecondaryButton type="button" onClick={onCloseValidationPopupClicked}>Close</SecondaryButton>
          </div>
        </div>
      </PopUpModal>
      <ClubStaffLoadingModal
        isError={state.pageErrorMessage !== ''}
        errorMessage={state.pageErrorMessage}
        isLoading={isSaving || isLoading}
        loadingMessage={isSaving ? SAVING_MSG : LOADING_MSG} />
    </Fragment>
  );
};

export default ClubStaffDetail;